import { default as Tag } from 'antd/es/tag';
import { useMemo } from 'react';
import { Link } from 'react-router-dom';

import '../navbar.css';

import { IPage } from '../models/pages';
import { AppSection } from '../pages/Section';
import { getCurrentEnv } from '../utils/getCurrentEnv';
import { DarkModeToggle } from './DarkModeToggle';
import { Logo } from './Logo';
import { OrgDropDown } from './OrgDropDown';
import { scrollToTop } from '../utils/scrollToTop';
import { enhanceLinkWithToken } from '../utils/enhanceLinkWithToken';
import {
  guideHeaderLinkDataTestId,
  referenceHeaderLinkDataTestId
} from './constants';

export interface HeaderProps {
  activeSection: AppSection;
  pages: IPage[];
}

export function Header(props: HeaderProps) {
  const activeLink =
    'underline underline-offset-4 text-inpay-green-secondary-light-1000';

  const CURRENT_ENV = useMemo(() => getCurrentEnv(window.location.host), []);

  return (
    <header className="header">
      <div className="flex flex-row items-center gap-6">
        <Link
          to={enhanceLinkWithToken('/guide/overview')}
          className="flex flex-row items-center gap-2"
        >
          <Logo className="size-14 text-white" />
          <span className="hidden lg:block">for Developers</span>
        </Link>
        {CURRENT_ENV !== 'prod' && (
          <Tag bordered={false} className="bg-inpay-yellow-1000">
            <p className="text-bold dark:text-black">{CURRENT_ENV}</p>
          </Tag>
        )}
        <DarkModeToggle />
      </div>
      <div className="flex items-center justify-center gap-6">
        <Link
          data-testid={guideHeaderLinkDataTestId}
          to={enhanceLinkWithToken('/guide/overview')}
          className={props.activeSection === 'guide' ? activeLink : ''}
          onClick={scrollToTop}
        >
          Documentation
        </Link>
        <Link
          data-testid={referenceHeaderLinkDataTestId}
          to={enhanceLinkWithToken('/reference/getting-started')}
          className={props.activeSection === 'reference' ? activeLink : ''}
          onClick={scrollToTop}
        >
          API Reference
        </Link>
      </div>
      <div className="flex items-center justify-end gap-4">
        <Link
          to={enhanceLinkWithToken('/support')}
          className={props.activeSection === 'support' ? activeLink : ''}
        >
          Support
        </Link>
        <OrgDropDown />
      </div>
    </header>
  );
}
